import { render, staticRenderFns } from "./HospitalNewDeparmentAdd.vue?vue&type=template&id=9000310a&"
import script from "./HospitalNewDeparmentAdd.vue?vue&type=script&lang=js&"
export * from "./HospitalNewDeparmentAdd.vue?vue&type=script&lang=js&"
import style0 from "./HospitalNewDeparmentAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports